import { InputFormCallout, InputFormCalloutProps, TextInput, TextInputTypes } from "o4a-react";
import * as React from "react";
import { Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { adbsWalletPwdMaxLength, adbsWalletPwdMinLength, WalletPasswordRegex } from "../../helpers/validationHelper";

export type AdbsWalletDownloadProps = Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit" | "componentRef">;

export const enum Fields {
  Password = "password",
  ConfirmPassword = "confirmPassword"
}

export const AdbsWalletDownload = (
  { targetId, onClose, onSubmit, componentRef }: AdbsWalletDownloadProps,
): JSX.Element => {
  const [password, setPassword] = React.useState<string>();
  return (
    <InputFormCallout
      componentRef={componentRef}
      title={Messages.createNewPanels.walletDownload.title()}
      targetId={targetId}
      onSubmit={onSubmit}
      onClose={onClose}
    >
      <Text>
        {Messages.createNewPanels.walletDownload.description()}
      </Text>
      <TextInput
        required
        fieldName={Fields.Password}
        label={Messages.labels.password()}
        tooltip={Messages.hints.tooltipWalletPassword()}
        textType={TextInputTypes.PASSWORD}
        onChange={value => { setPassword(value); }}
        validator={(value: string) => {
          const errors: string[] = [];
          if (value?.length < adbsWalletPwdMinLength || value?.length > adbsWalletPwdMaxLength) {
            errors.push(Messages.validation.inputRange(
              adbsWalletPwdMinLength.toString(),
              adbsWalletPwdMaxLength.toString(),
            ));
          } else if (!WalletPasswordRegex.test(value)) {
            errors.push(Messages.validation.walletPasswordValidation());
          }

          return errors.length > 0 ? errors : undefined;
        }}
      />
      <TextInput
        required
        fieldName={Fields.ConfirmPassword}
        label={Messages.labels.passwordConfirm()}
        textType={TextInputTypes.PASSWORD}
        validator={(value: string) => {
          if (value && (value !== password)) {
            return [Messages.validation.passwordConfirmation()];
          }
          return undefined;
        }}
      />
    </InputFormCallout>
  );
};
